import RegisterForm from './RegisterForm';
import { Link } from 'react-router-dom';
import './RegisterView.css';

export default function RegisterView() {
    return <div className="popup registerView">
        <div className="title"><img alt="Kingds and Emperors" src="logo.png"/> Kings and Emperors</div>
        <div className="separator"/>
        <div className='content'>
            <RegisterForm/>
            <div className="loginLink">
                Or <Link to="/login">click here to login</Link>
            </div>
        </div>
    </div>
};